import { render, staticRenderFns } from "./my-Chat.vue?vue&type=template&id=797f2444&scoped=true"
import script from "./my-Chat.vue?vue&type=script&lang=js"
export * from "./my-Chat.vue?vue&type=script&lang=js"
import style0 from "./my-Chat.vue?vue&type=style&index=0&id=797f2444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797f2444",
  null
  
)

export default component.exports